import React, { useEffect, useState } from 'react';
import Spinner from '../layouts/Spinner';
import { connect } from 'react-redux';
import {
    getExpiry,
    handleSearchInput,
    getSingleExpiry,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    // confirmDeleteDialogBox,
    setModal,
    handleChangeExpiryView,
} from '../../redux/actions/expiry/expiry.actions';
import ReactTooltip from 'react-tooltip';
import { formattedDate } from '../../Utils/Common';
import { useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { Show, useAccess } from 'react-redux-permission';
import { Link } from 'react-router-dom';
import { useDebounce } from 'use-debounce';
import {
    handleHover,
    setMUIPage,
    updateMUISetting,
} from '../../redux/actions/helper/helper.actions';
import ExpiryDateFilter from './ExpiryDate.filter';

function Exiry({
    expiry: {
        expiries,
        set_row_checked,
        pagination,
        search,
        loading,
        edit_url,
        create_url,
        history_url,
        sort_order_name,
        sort_order_direction,
        expiry_view,
    },
    getExpiry,
    handleSearchInput,
    getSingleExpiry,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    // confirmDeleteDialogBox,
    handleHover,
    hoverIndex,
    updateMUISetting,
    setMUIPage,
    muiPage,
    setModal,
    handleChangeExpiryView,
}) {
    const { hasPermission } = useAccess();

    const canCreate = hasPermission('inv.inventory.expiry.create');
    const canDelete = hasPermission('inv.inventory.expiry.delete');
    const canEdit = hasPermission('inv.inventory.expiry.edit');
    const canview = hasPermission('inv.inventory.expiry.view');
    const canViewHistroy = hasPermission('inv.inventory.expiry.history');

    // START DEVOUNCED SEARCH
    const debouncedSearch = useDebounce(search, 800);
    const [oldDebounced, setOldDebounced] = useState('');

    const [copiedId, setCopiedId] = useState(null);

    useEffect(() => {
        if (debouncedSearch) {
            if (debouncedSearch[0]) {
                if (oldDebounced !== debouncedSearch[0]) {
                    if (debouncedSearch[0].length !== 1) {
                        if (canview) {
                            setOldDebounced(debouncedSearch[0]);
                            getExpiry();
                        }
                    }
                }
            } else {
                if (oldDebounced !== '') {
                    if (canview) {
                        setOldDebounced('');
                        getExpiry();
                    }
                }
            }
        }
    }, [debouncedSearch]);
    // END DEVOUNCE SEARCH

    useEffect(() => {
        getExpiry(muiPage);
    }, []);

    let history = useHistory();
    const changePage = (link) => history.push(link);

    const getMuiTheme = () =>
        createMuiTheme({
            overrides: {
                MUIDataTable: {
                    root: {},
                    paper: {
                        boxShadow: 'none',
                    },
                },
                MUIDataTableBodyRow: {
                    root: {
                        '&:nth-child(odd)': {
                            backgroundColor: 'rgba(0,0,0,.05)',
                        },
                    },
                },
                MuiTableRow: {
                    hover: {
                        '&:hover': {
                            backgroundColor: '#bfcfe4 !important',
                        },
                    },
                },
                MUIDataTableBodyCell: {
                    root: {
                        '&:nth-child(2)': {
                            height: '61px',
                            width: '250px',
                        },
                        '&:nth-child(3)': {
                            width: '250px',
                            'text-align': 'justify',
                        },
                        '&:nth-child(4)': {
                            width: '250px',
                        },
                        '&:nth-child(5)': {
                            width: '250px',
                        },
                        '&:nth-child(6)': {
                            width: '150px',
                        },
                    },
                },
            },
        });

    const columns = [
        {
            name: 'expiry_date',
            label: 'Expiry Date',
            options: {
                display: true,
                customBodyRender: (value) => {
                    return <span> {value.substr(0, 10)} </span>;
                },
                setCellProps: (value) => {
                    return { className: 'cursor-pointer' };
                },
            },
        },
        {
            name: 'product_name',
            label: 'Product Name',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    let id = expiries[tableMeta['rowIndex']].product_id;
                    return <Link to={`/inventory/view/${id}`}>{value}</Link>;
                },
                setCellHeaderProps: (value) => {
                    return { className: 'cursor-pointer text-center' };
                },
            },
        },
        {
            name: 'description',
            label: 'Description',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span> {value} </span>;
                },
                setCellHeaderProps: (value) => {
                    return { className: 'cursor-pointer text-center' };
                },
            },
        },
        {
            name: 'sku',
            label: 'SKU',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span> {value} </span>;
                },
                setCellHeaderProps: (value) => {
                    return { className: 'cursor-pointer text-center' };
                },
            },
        },
        {
            name: 'quantity',
            label: 'Qty',
            options: {
                filter: false,
                sort: false,
                setCellProps: (value) => {
                    return { className: 'cursor-pointer' };
                },
                customBodyRender: (value) => value || 'N/A',
            },
        },
        {
            name: 'brand',
            label: 'Brand',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span> {value} </span>;
                },
                setCellHeaderProps: (value) => {
                    return { className: 'cursor-pointer text-center' };
                },
            },
        },
        {
            name: 'category',
            label: 'Category',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span> {value} </span>;
                },
                setCellHeaderProps: (value) => {
                    return { className: 'cursor-pointer text-center' };
                },
            },
        },
        {
            name: 'product_unit',
            label: 'UOM',
            options: {
                display: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    return <span> {value} </span>;
                },
                setCellHeaderProps: (value) => {
                    return { className: 'cursor-pointer text-center' };
                },
            },
        },
    ];

    const options = {
        serverSide: true,
        jumpToPage: true,
        filterType: 'dropdown',
        responsive: 'standard',
        search: false,
        filter: false,
        searchOpen: true,
        searchProps: {
            onBlur: (e) => {
                console.log('onBlur!');
            },
            onKeyUp: (e) => {
                console.log('onKeyUp!');
            },
        },
        rowsPerPageOptions: [10, 20, 50, 100, 200],
        rowsPerPage: pagination.itemsCountPerPage,
        count: pagination.totalItemsCount,
        page: pagination.activePage - 1,
        sortOrder: {
            name: sort_order_name,
            direction: sort_order_direction,
        },
        downloadOptions: {
            filename: `expiries_${formattedDate()}.csv`,
        },
        textLabels: {
            body: {
                noMatch: loading ? (
                    <Spinner />
                ) : (
                    'Sorry, there is no matching data to display'
                ),
            },
        },
        onChangeRowsPerPage: (numberOfRows) => {
            getExpiry(null, numberOfRows);
            updateMUISetting('rows', 'expiry', numberOfRows);
        },
        onTableChange: (action, tableState) => {
            // console.log(action, tableState);
            switch (action) {
                case 'changePage':
                    getExpiry(
                        tableState.page + 1,
                        pagination.itemsCountPerPage
                    );
                    setMUIPage(tableState.page + 1);
                    break;
                case 'sort':
                    // console.log(tableState.sortOrder.name, tableState.sortOrder.direction);
                    let column_name = tableState.sortOrder.name;
                    let direction = tableState.sortOrder.direction;
                    sortTableByColumn(column_name, direction);
                    break;
                case 'search':
                    // handleSearchInputMUI(tableState.searchText);
                    break;
                case 'rowSelectionChange':
                    let selectedRows = tableState.selectedRows.data;
                    let currentRows = tableState.data;
                    getSelectedRows(selectedRows, currentRows);
                    break;
                case 'propsUpdate':
                    // let update_checked = tableState.selectedRows = { data: [], lookup: {}, showResponsive: false };
                    if (set_row_checked) {
                        tableState.selectedRows['data'] = [];
                        tableState.selectedRows['lookup'] = {};
                        tableState.selectedRows['showResponsive'] = false;
                    } else {
                        return tableState;
                    }
                case 'viewColumnsChange':
                    updateMUISetting(
                        'columns',
                        'expiry',
                        null,
                        tableState.columns
                    );
                    break;
                default:
                    console.log('action not handled.');
            }
        },
        // onRowsDelete: () => {
        //     // Confirm Delete Modal
        //     if (canDelete) {
        //         // confirmDeleteDialogBox();
        //     }

        //     return false;
        // },
        onCellClick: (colData, cellMeta) => {
            // console.log(purchase_orders[cellMeta.dataIndex]._id);
            if (cellMeta.colIndex != 6) {
                if (canViewHistroy) {
                    // changePage(`${history_url}/${expiries[cellMeta.dataIndex]._id}`);
                }
            }
        },
        customSearchRender: (searchText, handleSearch, hideSearch, options) => {
            return (
                <div className="custom-search">
                    <i className="ft ft-search"></i>{' '}
                    <input
                        type="text"
                        name="search"
                        onKeyUp={handleSearchInputMUI}
                        className="custom-search-input"
                    />
                </div>
            );
        },
        setRowProps: (data, dataIndex, rowIndex) => {
            return {
                onMouseEnter: () => handleHover('in', rowIndex),
                onMouseLeave: () => handleHover('out', rowIndex),
            };
        },
    };
    if (!canDelete) {
        options.selectableRows = false;
    }

    const _columns = updateMUISetting('view-columns', 'expiry', null, columns);

    return (
        <>
            <div className="app-content content">
                <ReactTooltip effect="solid" event="click" />
                <div className="content-wrapper max-1920 mx-auto">
                    <div className="content-wrapper-before"></div>
                    <div className="content-header row">
                        <div className="content-header-left col-md-12 col-12 mb-2 breadcrumb-new fix-header">
                            <h3 className="content-header-title mb-0 d-inline-block">
                                Inventory
                            </h3>

                            <div className="breadcrumbs-top d-inline-block">
                                <div className="breadcrumb-wrapper mr-1">
                                    <ol className="breadcrumb f-regular">
                                        <li className="breadcrumb-item ">
                                            <a
                                                href="expiry"
                                                className="text-white"
                                            >
                                                {' '}
                                                Expiry
                                            </a>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Show when="inv.inventory.expiry.view">
                        <div className="content-body margin-top-5">
                            <section id="basic-examples">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div id="what-is" className="">
                                            <div className="card-content collapse show">
                                                <div className="card-body no-padding-top no-padding-left-right">
                                                    <section className="row">
                                                        <div className="col-sm-12">
                                                            <ul className="nav nav-tabs f-regular">
                                                                <li className="">
                                                                    <a
                                                                        onClick={() =>
                                                                            handleChangeExpiryView(
                                                                                'all'
                                                                            )
                                                                        }
                                                                        className={`nav-link ${
                                                                            expiry_view ===
                                                                            'all'
                                                                                ? 'active'
                                                                                : ''
                                                                        }`}
                                                                        id="base-tab1"
                                                                        data-toggle="tab"
                                                                        aria-controls="tab1"
                                                                        href="#tabs"
                                                                        aria-expanded={
                                                                            expiry_view ===
                                                                            'all'
                                                                        }
                                                                    >
                                                                        All
                                                                    </a>
                                                                </li>
                                                                <li className="">
                                                                    <a
                                                                        onClick={() =>
                                                                            handleChangeExpiryView(
                                                                                'expiring_soon'
                                                                            )
                                                                        }
                                                                        className={`nav-link ${
                                                                            expiry_view ===
                                                                            'expiring_soon'
                                                                                ? 'active'
                                                                                : ''
                                                                        }`}
                                                                        id="base-tab2"
                                                                        data-toggle="tab"
                                                                        aria-controls="tab2"
                                                                        href="#tabs"
                                                                        aria-expanded={
                                                                            expiry_view ===
                                                                            'expiring_soon'
                                                                        }
                                                                    >
                                                                        Expiring
                                                                        Soon
                                                                    </a>
                                                                </li>
                                                                <li className="">
                                                                    <a
                                                                        onClick={() =>
                                                                            handleChangeExpiryView(
                                                                                'expired'
                                                                            )
                                                                        }
                                                                        className={`nav-link ${
                                                                            expiry_view ===
                                                                            'expired'
                                                                                ? 'active'
                                                                                : ''
                                                                        }`}
                                                                        id="base-tab3"
                                                                        data-toggle="tab"
                                                                        aria-controls="tab3"
                                                                        href="#tabs"
                                                                        aria-expanded={
                                                                            expiry_view ===
                                                                            'expired'
                                                                        }
                                                                    >
                                                                        Expired
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                            <div className="tab-content px-1 pt-1 card-box-top card">
                                                                <div
                                                                    role="tabpanel"
                                                                    className="tab-pane active table-responsive"
                                                                    id="tabs"
                                                                    aria-expanded="true"
                                                                    aria-labelledby="base-tab1"
                                                                >
                                                                    <div className="card-header">
                                                                        <h4 className="card-title">
                                                                            {expiry_view ===
                                                                                'all' &&
                                                                                'List of Product Expiries'}
                                                                            {expiry_view ===
                                                                                'expiring_soon' &&
                                                                                'List of Expiring Products (Next 90 Days)'}
                                                                            {expiry_view ===
                                                                                'expired' &&
                                                                                'List of Expired Products'}{' '}
                                                                            <a
                                                                                href="#"
                                                                                className="tool-tip"
                                                                                data-tip="this is a tool tip"
                                                                            >
                                                                                <i className="la la-question-circle"></i>
                                                                            </a>
                                                                        </h4>
                                                                    </div>
                                                                    <div className="card-content collapse show">
                                                                        <div className="card-body">
                                                                            <ExpiryDateFilter />
                                                                            <section className="row">
                                                                                <div className="col-sm-12">
                                                                                    <MuiThemeProvider
                                                                                        theme={getMuiTheme()}
                                                                                    >
                                                                                        <MUIDataTable
                                                                                            title={
                                                                                                expiry_view ===
                                                                                                'all'
                                                                                                    ? 'List of Product Expiry'
                                                                                                    : expiry_view ===
                                                                                                      'expiring_soon'
                                                                                                    ? 'List of Product Expiring Soon'
                                                                                                    : 'List of Product Expired'
                                                                                            }
                                                                                            data={
                                                                                                expiries
                                                                                            }
                                                                                            columns={
                                                                                                _columns
                                                                                            }
                                                                                            options={
                                                                                                options
                                                                                            }
                                                                                        />
                                                                                    </MuiThemeProvider>
                                                                                </div>
                                                                            </section>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </Show>
                </div>
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    expiry: state.expiry,
    hoverIndex: state.helper.hoverIndex,
    muiPage: state.helper.muiPage,
});

export default connect(mapStateToProps, {
    getExpiry,
    handleSearchInput,
    getSingleExpiry,
    sortTableByColumn,
    handleSearchInputMUI,
    getSelectedRows,
    // confirmDeleteDialogBox,
    handleHover,
    updateMUISetting,
    setMUIPage,
    setModal,
    handleChangeExpiryView,
})(Exiry);
